import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExtCircService } from '../service/extCirc.service';

interface ExtCircApprovalDialogData {
  id: string;
  approve?: boolean;
  reject?: boolean;
}

interface ExtCircApprovalDialogResult {
  approved?: boolean;
  rejected?: boolean;
  reason?: string;
  cancelled?: boolean;
}

@Component({
    templateUrl: 'extCircApproveRejectDialog.component.html',
    styleUrls: ['./extCircApproveRejectDialog.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExtCircApproveRejectDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ExtCircApproveRejectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExtCircApprovalDialogData, private service: ExtCircService) {
  }

  reason!: string;
  header = '';
  reasonPlaceholder = '';


  ngOnInit () {
    this.header = this.data.approve ? 'Approve' : 'Reject';
    this.reasonPlaceholder = 'Please provide a reason for the ' + (this.data.approve ? 'approval' : 'rejection');

  }

  approve() {
    const result = { approved: true, reason: this.reason };
    this.service.approve(this.data.id, this.reason).subscribe(() => {
      this.close(result);
    }, error => {

    });

  }

  reject() {
    const result = { rejected: true, reason: this.reason };
    this.service.reject(this.data.id, this.reason).subscribe(() => {
      this.close(result);
    }, error => {

    });

  }

  close(result?: ExtCircApprovalDialogResult) {
    this.dialogRef.close(result || { cancelled: true });
  }



}
